
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Slack, MessageSquare, MessagesSquare, CheckCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface TabItem {
  id: string;
  icon: React.ReactNode;
  label: string;
  disabled?: boolean;
  badgeText?: string;
  badgeVariant?: "default" | "outline";
}

interface TabsContainerProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  tabs: TabItem[];
  children: React.ReactNode;
}

const TabsContainer: React.FC<TabsContainerProps> = ({
  activeTab,
  setActiveTab,
  tabs,
  children,
}) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="mb-4">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            disabled={tab.disabled}
            className="flex items-center gap-2"
          >
            {tab.icon}
            {tab.label}
            {tab.badgeText && (
              <Badge
                variant={tab.badgeVariant || "outline"}
                className="ml-2 bg-green-50 text-green-700 border-green-200"
              >
                <CheckCircle className="h-3 w-3 mr-1" /> {tab.badgeText}
              </Badge>
            )}
          </TabsTrigger>
        ))}
      </TabsList>

      {children}
    </Tabs>
  );
};

export default TabsContainer;
